import { ScenarioCounts, ScenarioCountsState } from '@/interfaces/IScenarioCounts';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { WorkflowType } from 'src/enums/EWorkflow';

const initialState: ScenarioCountsState = {
	counts: {
		[WorkflowType.TEXT]: 0,
		[WorkflowType.CALL]: 0,
		[WorkflowType.CALENDAR]: 0,
		[WorkflowType.WEBHOOK]: 0,
		[WorkflowType.INTAKE]: 0,
		[WorkflowType.EMAIL]: 0,
		total: 0,
	},
	limit: 100,
};

const scenarioCountsSlice = createSlice({
	name: 'scenarioCounts',
	initialState,
	reducers: {
		setScenarioCounts: (state, action: PayloadAction<ScenarioCounts>) => {
			const existingCalendarCount = state.counts[WorkflowType.CALENDAR];

			state.counts = {
				...action.payload,
				[WorkflowType.CALENDAR]: existingCalendarCount,
			};

			state.counts.total =
				state.counts[WorkflowType.TEXT] +
				state.counts[WorkflowType.CALL] +
				state.counts[WorkflowType.CALENDAR] +
				state.counts[WorkflowType.WEBHOOK] +
				state.counts[WorkflowType.INTAKE] +
				state.counts[WorkflowType.EMAIL];
		},
		setCalendarCount: (state, action: PayloadAction<number>) => {
			const oldCalendarCount = state.counts[WorkflowType.CALENDAR];
			const oldTotal = state.counts.total;
			const newTotal = oldTotal - oldCalendarCount + action.payload;

			state.counts[WorkflowType.CALENDAR] = action.payload;
			state.counts.total = newTotal;
		},
		incrementScenarioCount: (state, action: PayloadAction<WorkflowType>) => {
			if (state.counts.total < state.limit) {
				state.counts[action.payload]++;
				state.counts.total++;
			}
		},
		decrementScenarioCount: (state, action: PayloadAction<WorkflowType>) => {
			if (state.counts[action.payload] > 0) {
				state.counts[action.payload]--;
				state.counts.total--;
			}
		},
		setScenarioLimit: (state, action: PayloadAction<number>) => {
			state.limit = action.payload;
		},
	},
});

export const {
	setScenarioCounts,
	setCalendarCount,
	incrementScenarioCount,
	decrementScenarioCount,
	setScenarioLimit,
} = scenarioCountsSlice.actions;

export default scenarioCountsSlice.reducer;
